import React from "react";

const FieldError = (props) => {
  return props.errors?.[props.name] && props.touched?.[props.name] ? (
    <p className="text-sm text-theme-error-input">{props.errors?.[props.name]}</p>
  ) : null;
};

export default FieldError;
